import { Pipe, PipeTransform } from '@angular/core';
import { SimilarHtsSuggestionModel } from '@data-layer/models/common';
import { FavoriteHtsNumberModel } from '@data-layer/models/common/favorite-hts-number.model';
import { HtsAssistantHelper } from '@shared/hts-assistant/helpers/hts-assistant.helper';

/**
 * `HtsAssistantHelper.withoutCatalogCodes` for templates (#13533). Pure: the host must replace its arrays, not mutate them.
 */
@Pipe({ name: 'htsSuggestionsWithoutCatalog' })
export class HtsSuggestionsWithoutCatalogPipe implements PipeTransform {
  public transform(
    suggestions: SimilarHtsSuggestionModel[] | null | undefined,
    catalogItems: FavoriteHtsNumberModel[] | null | undefined,
  ): SimilarHtsSuggestionModel[] {
    return HtsAssistantHelper.withoutCatalogCodes(suggestions, catalogItems);
  }
}
